import { render, staticRenderFns } from "./verification-history.vue?vue&type=template&id=6da7aef6&"
import script from "./verification-history.vue?vue&type=script&lang=js&"
export * from "./verification-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports